import {
    apiRequest,
    cpnsPeriodList,
    cpnsPeriodInactive,
    cpnsPeriodActive
} from "../../../../../services/adapters/kepegawaian/cpnsService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", cpnsPeriodList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", cpnsPeriodInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", cpnsPeriodActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository